

































































import Vue from 'vue';

import TableFilters from '@/containers/TableFilters';
import TableToolbar from '@/containers/TableToolbar';
import ResourceTable from '@/containers/ResourceTable';

import { TableAction, ParamSettings, CellRenderers, Nullable } from '@/types';
import Gmap from '@/components/gmap/Gmap.vue';
import { Route } from 'vue-router';

export default Vue.extend({
  props: {
    itemKey: {
      type: String,
    },

    filters: {
      type: Function,
    },

    resource: {
      type: String,
    },

    settings: {
      type: String,
    },

    dictionaries: {
      type: [String, Array],
    },

    scope: {
      type: Object as () => ParamSettings,
      default: () => ({} as ParamSettings),
    },

    actions: {
      type: Array as () => TableAction[],
      default: () => [],
    },

    navigation: {
      type: Function,
    },

    navigateTo: {
      type: Function,
      default: () => {},
    },

    relationId: {
      type: [String, Number],
    },
  },
  watch: {
    route() {
      this.tab = 0; // reset to table view when navigating to other category
    },
  },

  components: {
    TableToolbar,
    TableFilters,
    ResourceTable,
    Gmap,
  },

  data() {
    return {
      tab: null as Nullable<number>,
    };
  },

  created() {
    window.addEventListener('resize', this.handleResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  mounted() {
    this.handleResize();
    if (this.route.hash === '#map') {
      this.tab = 1;
    }
  },

  methods: {
    handleResize() {
      this.$store.commit('ui/set:mainHeight', 0);
      this.$nextTick(() => {
        const main = document.getElementsByClassName('v-main__wrap')[0];

        this.$store.commit('ui/set:mainHeight', main.clientHeight - 24);
      });
    },
  },

  computed: {
    route(): Route {
      return this.$store.state.route;
    },
    showFullscreen: {
      get(): boolean {
        return this.$store.state.ui.showFullscreen;
      },

      set(val: boolean): void {
        this.$store.commit('ui/set:showFullscreen', val);
      },
    },

    limit(): Record<string, any> {
      return this.scope.limit || {};
    },

    includedFilters(): Record<string, boolean> {
      const filters = Object.values(this.scope.filters!).filter(
        key =>
          (!this.scope.include?.length || this.scope.include?.includes(key)) &&
          !this.scope.exclude?.includes(key),
      );

      return filters.reduce(
        (params, key) => ({
          ...params,
          [key]: true,
        }),
        {},
      );
    },

    tableSettings(): string {
      return this.settings || `${this.resource}/settings`;
    },

    renderers(): CellRenderers {
      return this.$store.getters[`${this.tableSettings}/renderers`];
    },
  },
});
